import { FileText, Quote } from "lucide-react";
import {
  Sheet, SheetContent, SheetHeader, SheetTitle,
} from "@/components/ui/sheet";

const STR = {
  tr: { title: "Kaynak", page: "Sayfa", section: "Bölüm", noSnippet: "Bu kaynak için önizleme metni yok.",
        hint: "Yanıt bu belge parçasına dayanıyor." },
  en: { title: "Source", page: "Page", section: "Section", noSnippet: "No preview text for this source.",
        hint: "The answer is grounded in this document excerpt." },
};

// Side panel that opens the document chunk behind a clicked [n] citation and highlights it.
export default function SourceSheet({ cite, onClose, lang = "tr" }) {
  const t = STR[lang] || STR.tr;
  const path = (cite?.section_path || []).join(" › ");
  return (
    <Sheet open={!!cite} onOpenChange={(o) => !o && onClose?.()}>
      <SheetContent className="w-full overflow-y-auto sm:max-w-md" data-testid="source-sheet">
        <SheetHeader>
          <SheetTitle className="flex items-center gap-2">
            {cite?.n != null && (
              <span className="mono flex h-6 w-6 items-center justify-center rounded-md bg-foreground text-[11px] font-semibold text-background">
                {cite.n}
              </span>
            )}
            <FileText className="h-4.5 w-4.5" /> {t.title}
          </SheetTitle>
        </SheetHeader>

        <div className="mt-4 space-y-3">
          <div className="font-semibold text-foreground" data-testid="source-document">
            {cite?.document || t.title}
          </div>
          {path && (
            <div className="text-xs text-muted-foreground">
              <span className="font-medium">{t.section}:</span> {path}
            </div>
          )}
          {cite?.page != null && (
            <div className="text-xs text-muted-foreground">{t.page} {cite.page}</div>
          )}

          <div
            data-testid="source-snippet"
            className="rounded-xl border border-amber-200 bg-amber-50 p-3.5 text-sm leading-relaxed text-amber-900"
          >
            <div className="mb-1.5 flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-amber-600">
              <Quote className="h-3.5 w-3.5" /> {t.title}
            </div>
            {cite?.snippet ? cite.snippet : <span className="italic opacity-70">{t.noSnippet}</span>}
          </div>

          <p className="text-xs text-muted-foreground">{t.hint}</p>
        </div>
      </SheetContent>
    </Sheet>
  );
}
